import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import NutrizioneSuperiorePerIlTuoGatto from "./sections/NutrizioneSuperiorePerIlTuoGatto";
import InitiateCoordination from "./sections/InitiateCoordination";
import TailoredShineSolutions from "./sections/TailoredShineSolutions";
import IndustryPartners from "./sections/IndustryPartners";
import EcosystemFeatures from "./sections/EcosystemFeatures";
import StartYourProjectAnalysis from "./sections/StartYourProjectAnalysis";
import Footer from "@/reusable_sections/Footer";
import ParticipationForm from "./sections/ParticipationForm";
import SocialConnect from "./sections/SocialConnect";
export default function HomePage() {
  return <div>
      <Header />
      <NutrizioneSuperiorePerIlTuoGatto />
      <InitiateCoordination />
      <TailoredShineSolutions />
      <IndustryPartners />
      <ParticipationForm />
      <EcosystemFeatures />
      <StartYourProjectAnalysis />
      <SocialConnect />
      <Footer />
    </div>;
}